import {ImgLabel} from "@/store/model/ImgLabel";
import {LocalDate} from "@js-joda/core";
import {Email} from "@/store/model/Email";
import {formatZonedDateTime} from "@/baseUtils";

export class PoliticianProfile {

    constructor(data) {

        this.id = data.id;
        this.status = data.status; // BiActiveState
        this.user = new ImgLabel(data.user);
        this.firstName = data.firstName;
        this.lastName = data.lastName;
        this.gender = data.gender; // UserGender
        this.birthday = data.birthday ? LocalDate.parse(data.birthday) : null;
        this.webSite = data.webSite;
        this.emails = data.emails.map((email) => new Email(email));
        this.createdDateTime = formatZonedDateTime(data.createdDateTime);
        this.updatedDateTime = formatZonedDateTime(data.updatedDateTime);
    }
}